export const version = '2.49.4';
//# sourceMappingURL=version.js.map